//
//
//
//
//

export default {
    name: 'mt-layout-container-multiple-item',
    methods: {
        handleClick(evt) {
            this.$emit('click', evt);
        }
    },
    props: {
        width: String
    },
    computed: {
        styleComputed: function() {
            let _style = '';
            let width = this.width;
            if (width) {
                _style += 'width:'+width;
            }
            return _style;
        }
    }
};



// WEBPACK FOOTER //
// ./packages/layout-container-multiple-item/src/layout-container-multiple-item.vue